<template>

  <v-app>

    <v-text-field label="انتخاب سطح دسترسی" :value="manufacturer_name" dense
                  outlined readonly append-icon="mdi-crosshairs" class="cursor-pointer" @click="dialog = true"
                  ref="input" :error-messages="errors"/>

    <v-dialog v-model="dialog" scrollable max-width="800px">
      <v-card elevation="2" outlined :loading="loading">
        <v-card-title>انتخاب سطح دسترسی</v-card-title>
        <v-divider></v-divider>
        <v-row>
          <v-card-text v-if="service==null">لطفا سرویس خود را انتخاب کنید!</v-card-text>
        </v-row>
        <v-card-actions class="mt-4">

          <v-row>
            <v-col cols="6">
              <v-flex xs12 sm12 md6 lg6 xl6>
                <v-text-field label="جستجو" append-icon="mdi-magnify"
                              v-model="search" @change="fetch"
                />
              </v-flex>


            </v-col>


            <v-col cols="6">


              <v-flex xs12 sm12 md6 lg6 xl6>
                <v-select
                    v-model="service"
                    @change="this.fetch"
                    :items="services"
                    item-text="nameLand"
                    item-value="id"
                    label="انتخاب سرویس"
                    outlined
                    dense
                    return-object
                ></v-select>
              </v-flex>


            </v-col>
          </v-row>


        </v-card-actions>

        <v-card-text>


          <v-row justify="center">
            <v-expansion-panels popout>
              <v-expansion-panel
                  v-for="category in categories.data"
                  v-if="category.permission.length"
                  :key="category.id"
              >
                <v-expansion-panel-header><b>
                  {{ category.name }}
                </b>
                </v-expansion-panel-header>
                <v-expansion-panel-content>


                  <v-flex v-for="permission in category.permission" :key="permission.id">
                    <v-row>

                      <v-col cols="6">
                        <v-checkbox
                            v-model="value[permission.id]"
                            @change="(n)=>{n ? addPerm(permission.id, category.service_id) : removePerm(permission.id)}"
                            :label="permission.name_fa"
                        ></v-checkbox>
                      </v-col>

                      <v-col
                          v-if="value[permission.id]"
                          cols="6"
                          class="py-2"
                      >
                        <p>انتخاب وضعیت</p>

                        <v-btn-toggle
                            rounded
                            @change="(n)=>{if(!n) value[permission.id].type = 'active'}"
                            v-model="value[permission.id].type"
                            color="#2196f3"
                            borderless
                        >
                          <v-btn value="active">
                            <span class="hidden-sm-and-down">فعال</span>
                            <v-icon right>
                              mdi-check-circle-outline
                            </v-icon>
                          </v-btn>

                          <v-btn value="deactive">
                            <span class="hidden-sm-and-down">غیرفعال</span>

                            <v-icon right>
                              mdi-cancel
                            </v-icon>
                          </v-btn>

                          <v-btn value="show">
                            <span class="hidden-sm-and-down">فقط مشاهده</span>
                            <v-icon right>
                              mdi-eye
                            </v-icon>
                          </v-btn>

                        </v-btn-toggle>
                      </v-col>
                    </v-row>
                  </v-flex>


                </v-expansion-panel-content>

              </v-expansion-panel>
              <!--              <v-flex-->
              <!--                  :class="'xs12 sm12 md12 lg12 xl12'"-->
              <!--                  class="p-2 mt-5">-->

              <!--                <v-btn-->
              <!--                    color="#2196f3"-->
              <!--                    primary-->
              <!--                    class="text-white"-->
              <!--                    block-->
              <!--                    v-text="'ذخیره'"-->
              <!--                    @click="pick">-->
              <!--                </v-btn>-->
              <!--              </v-flex>-->
            </v-expansion-panels>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <!--        <v-card-actions>-->
        <!--          <pagination :data="permissions.data" :visible="2" v-on:page="fetch"/>-->

        <!--          <v-spacer/>-->

        <!--          <v-btn color="primary" class="mr-auto" text @click="dialog = false">بستن</v-btn>-->
        <!--        </v-card-actions>-->
      </v-card>
    </v-dialog>
  </v-app>

</template>

<script>
import pagination from "@/view/pages/pickers/pagination";
import routePagination from "@/view/content/route-pagination";

export default {
  components: {pagination, routePagination},
  name: "permissionPicker",

  props: {
    value: {
      type: Object,
      default: {}
    },
    errors: [],
  },

  // props: ['value', 'errors'],

  // model: {
  //   prop: 'value',
  //   event: 'manufacturersPicker'
  // },

  computed: {
    manufacturer_name: function () {
      if (this.model === null) return "";
      return this.model.name;
    }
  },

  data: () => ({
    dialog: false,
    loading: false,
    search: null,
    service: null,
    permissions: [],
    categories: [],
    icon: 'justify',
    checkedPermissions: {},
    typePermissions: {},
    servicePermissions: {},
    data: {},
    toggle_none: null,
    showColor: 'red darken-3',
    activeColor: 'red darken-3',
    deactiveColor: 'red darken-3',
    services: [],
    toggle_one: 0,
    toggle_exclusive: 2,
    toggle_multiple: [0, 1, 2],
    model: null,
  }),

  created() {
    this.services = this.getService().data;
    this.fetch();
  },

  methods: {
    fetch(page = 1) {
      let data = {}
      // if (this.service !== null) {
      //   data = {
      //     search: this.search,
      //     service_id: this.service.id,
      //     length: 100
      //   }
      //
      // } else {
      //
      //   data = {
      //     search: this.search,
      //     length: 100
      //   }
      //
      // }


      this.requestApiGet('admin/categoryPermission', {
        search: this.search,
        service_id: this.service.id,
        length: 100
      }
      )
          .then(({data}) => {
            this.categories = data
          })
          .catch(({response}) => this.$root.$emit('errorToast', response.data.message))
          .finally(() => this.loading = false);
    },

    addPerm(id, serviceId) {
      let temp = this.cloneObject(this.value)
      temp[id] = {type: "active", service_id: serviceId}

      this.$emit("input", temp)
    },
    removePerm(id) {
      let temp = this.cloneObject(this.value);
      delete temp[id]
      this.$emit("input", temp)
    },
  }

}
</script>

<style scoped>

</style>
